export default __webpack_public_path__ + "static/media/CSRealCase3.1961e199.jpg";